import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    AbstractControl,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    UntypedFormBuilder,
    UntypedFormGroup,
    ValidationErrors
} from "@angular/forms";
import { EMPTY, Observable, of, Subscription } from "rxjs";
import {
    arrayIsSet,
    isNotNullOrUndefined,
    objectIsSet,
    stringIsSet
} from "../../providers/service/global-variables.service";
import { map, startWith, switchMap } from "rxjs/operators";
import { OpenDialogService } from "../../providers/service/open-dialog.service";

@Component({
    selector: 'app-input-text-array-form-field',
    templateUrl: './input-text-array-form-field.component.html',
    styleUrls: ['./input-text-array-form-field.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: InputTextArrayFormFieldComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: InputTextArrayFormFieldComponent
        }
    ],
    standalone: false
})
export class InputTextArrayFormFieldComponent implements OnInit, OnDestroy {
    @Input() title: string | undefined;
    @Input() enableDisabelEmitEvent = true;
    public form: UntypedFormGroup;
    numberElements$: Observable<number>;
    private subScriptions: Subscription = new Subscription();

    constructor(private fb: UntypedFormBuilder,
        private openDialogService: OpenDialogService) {
        this.form = this.fb.group({ value: undefined, currentValue: undefined });
        this.numberElements$ = this.form.get('value')?.valueChanges.pipe(
            startWith(this.form.get('value')?.value),
            map(values => arrayIsSet(values) ? values.length : 0)
        ) as Observable<number>
    }

    ngOnInit(): void {
    }

    ngOnDestroy() {
        this.subScriptions.unsubscribe();
    }

    unsetValue() {
        this.form.get('value')?.reset();
    }

    onTouched: Function = () => {
    };

    registerOnChange(onChange: any) {
        const sub = this.form.get('value')?.valueChanges
            .subscribe(onChange);
        if (sub instanceof Subscription) {
            this.subScriptions.add(sub);
        }

    }

    registerOnTouched(onTouched: Function) {
        this.onTouched = onTouched;
    }

    setDisabledState(disabled: boolean) {
        if (disabled) {
            this.form.disable({ emitEvent: this.enableDisabelEmitEvent });
        } else {
            this.form.enable({ emitEvent: this.enableDisabelEmitEvent });
        }
    }

    writeValue(value: any) {
        if (arrayIsSet(value)) {
            this.form.get('value')?.setValue(value);
        } else {
            this.form.get('value')?.reset();
        }
        setTimeout(() => {
            this.form.get('value')?.updateValueAndValidity()
        }, 50)
    }

    validate(control: AbstractControl): ValidationErrors | null {
        if (!isNotNullOrUndefined(this.form.get('value')?.validator)) {
            this.form.get('value')?.setValidators(control.validator);
        }
        const errors = this.form.get('value')?.errors
        if (errors && 'required' in errors && arrayIsSet(this.form.get('value')?.value)) {
            delete errors.required
            if (objectIsSet(errors)) {
                this.form.get('value')?.setErrors(errors)
            } else {
                this.form.get('value')?.setErrors(null)
            }
        }
        if (this.form.get('value')?.valid) {
            return null;
        } else {
            return this.form.get('value')?.errors!;
        }
    }

    addValue() {
        const currentValue = this.form.get('currentValue')?.value
        if (stringIsSet(currentValue)) {
            let values = this.form.get('value')?.value
            if (arrayIsSet(values)) {
                const index = values.findIndex(v => v === currentValue);
                if (index < 0) {
                    values = [...values, currentValue];
                }
            } else {
                values = [currentValue];
            }
            this.form.get('value')?.setValue(values);
            setTimeout(() => {
                this.form.get('value')?.updateValueAndValidity();
            })
            this.form.get('currentValue')?.reset();
        }
    }

    showLine() {
        const values = this.form.get('value')?.value
        if (arrayIsSet(values)) {
            const valuess: {
                title: { traduction?: string, value?: any },
                value: { traduction?: string, value?: any }
            }[] = [];
            values.forEach(value => {
                valuess.push({ title: { traduction: undefined, value }, value: {} });
            });
            this.openDialogService.openShowRawDetail(valuess, undefined, true).pipe(
                switchMap((values) => {
                    if (values) {
                        if (arrayIsSet(values.values)) {
                            return of(
                                values.values.map(
                                    v => v.title.value
                                )
                            )
                        } else {
                            return of(
                                (values as any).map(
                                    (v: any) => v.title.value
                                )
                            )
                        }
                    }

                    return EMPTY

                })
            )
                .subscribe(values => {
                    this.form.get('value')?.setValue(values);
                }, error => {
                    console.error(error);
                })
        }
    }
}
